import type { D4signContract } from '../services/contract-management.service';

export function isContractSignedOrPartial(contract: {
  statusId?: string | null;
  statusName?: string | null;
}): boolean {
  if (contract.statusId === '1' || contract.statusId === '4') return true;
  const name = (contract.statusName ?? '').trim().toLowerCase();
  return name === 'signed' || name === 'finished document';
}

export function isContractFullySigned(contract: {
  statusId?: string | null;
  statusName?: string | null;
}): boolean {
  if (contract.statusId === '1') return true;
  const name = (contract.statusName ?? '').trim().toLowerCase();
  return name === 'finished document';
}

export function isContractPartialSignature(contract: {
  statusId?: string | null;
  statusName?: string | null;
}): boolean {
  return isContractSignedOrPartial(contract) && !isContractFullySigned(contract);
}

export function requiresContaAzulConfirmation(contract: D4signContract): boolean {
  return isContractPartialSignature(contract);
}

export function getGoogleDocOpenUrl(contract: {
  googleDocId?: string | null;
  googleDocWebViewUrl?: string | null;
}): string | null {
  if (contract.googleDocWebViewUrl) return contract.googleDocWebViewUrl;
  if (contract.googleDocId) {
    return `https://docs.google.com/document/d/${contract.googleDocId}/edit`;
  }
  return null;
}

export function getDraftGoogleDocOpenUrl(draft: {
  embedEditUrl?: string | null;
  googleDocId: string;
}): string {
  if (draft.embedEditUrl) {
    return draft.embedEditUrl.replace('?rm=minimal', '').replace('&rm=minimal', '');
  }
  return `https://docs.google.com/document/d/${draft.googleDocId}/edit`;
}
